import { DataBean } from "../DataBean";

export class IncapacityLiquidation extends DataBean {



    public async createIncapacityLiquidation(
    accountantDate: any,
    idDocument: number,
    documentDate: any,
    noveltyID: number,
    idWelfareEntity: number,
    description: string,
    idLoggedEmployee: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.AccountantDocument_createIncapacityLiquidation_java.util.Date_Number_java.util.Date_Number_Number_String_Number",
      [
        accountantDate,
        idDocument,
        documentDate,
        noveltyID,
        idWelfareEntity,
        description,
        idLoggedEmployee,
      ]
    );
  }
}